import {GetUnlockCouponInfoRequest} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coupons/v1/service.types';
import {useCurrentPageType} from '@aboutyou/router';
import {useMemo, useRef} from 'react';
import {useBrandShopIdentifier} from '../../../backend-services/BrandHub/utils/useBrandShopIdentifier';
import {useCategoryIdentifierFooter} from '../../../backend-services/Footer/utils/useCategoryIdentifierFooter';
import {useProductIdentifier} from '../../../shared-deprecated/useProductIdentifier';

export const useUnlockCouponInfoRequestIdentifier = () => {
  const entryPageType = useRef(useCurrentPageType()).current;
  const categoryIdentifier = useRef(useCategoryIdentifierFooter()).current;
  const productIdentifier = useRef(useProductIdentifier()).current;
  const brandIdentifier = useRef(useBrandShopIdentifier()).current;

  const identifier: GetUnlockCouponInfoRequest['identifier'] = useMemo(() => {
    switch (entryPageType) {
      case 'category': {
        return {
          $case: 'category',
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @typescript-eslint/no-non-null-asserted-optional-chain
          category: categoryIdentifier?.categoryIdentifier!,
        };
      }
      case 'articleDetail':
        return {
          $case: 'product',
          product: {identifier: productIdentifier!},
        };

      case 'brandShop':
        return {
          $case: 'brand',
          brand: {identifier: brandIdentifier},
        };
      default:
        return {
          $case: 'couponLandingPage',
          couponLandingPage: {},
        };
    }
  }, [
    brandIdentifier,
    categoryIdentifier?.categoryIdentifier,
    entryPageType,
    productIdentifier,
  ]);

  return identifier;
};
